// extracted by mini-css-extract-plugin
module.exports = {"forgot_password_form":"ForgotPasswordForm_forgot_password_form__35k1V","warn_text":"ForgotPasswordForm_warn_text__2w6cu"};